module.exports = __webpack_public_path__ + "assets/img/18_1733_big.516b3f6e.jpg";